var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarIndicatorActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 8,
    viewBox: "0 0 6 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.249999 4.43301C-0.0833339 4.24056 -0.0833335 3.75944 0.25 3.56699L4.75 0.96891C5.08333 0.77646 5.5 1.01702 5.5 1.40192L5.5 6.59808C5.5 6.98298 5.08333 7.22354 4.75 7.03109L0.249999 4.43301Z",
    fill: "#33BCBF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarIndicatorActive);
export default __webpack_public_path__ + "static/media/sidebar-indicator-active.f8c03b4ee8ce5b4c908f71e25553b3d8.svg";
export { ForwardRef as ReactComponent };